import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { withHandlers } from 'recompose'
import { compose } from 'redux'
import {
  markActivityRead
} from '../../../store/actions/activity'
import getUrl from '../../../utils/getUrl'

const ActivityItemContainer = compose(
  connect(
    () => ({}),
    {
      goTo: push,
      markActivityRead
    }
  ),
  withHandlers({
    onClick: ({
      activityItem,
      markActivityRead,
      goTo
    }) => () => {
      switch (activityItem.type) {
        case 'discuss.thread':
        case 'discuss.reply':
        case 'discuss.resolved':
          goTo(
            getUrl({
              type: 'board',
              id: activityItem.boardId,
              name: activityItem.boardName
            }) +
              '#t' +
              activityItem.threadId,
            activityItem.blockId
              ? {
                  scrollTo: activityItem.blockId
                }
              : {}
          )
          break

        case 'announcement':
          if (activityItem.link) {
            if (activityItem.link.match(/^https?:\/\//))
              window.open(activityItem.link, '_blank')
            else goTo(activityItem.link)
          }
          break

        default:
          break
      }

      markActivityRead(activityItem.id)
    }
  }),
  withTranslation()
)

export default ActivityItemContainer
